import { UrjaMark } from "../../Assets/Images";

// Branded loader: the EVA mark on a green core, wrapped in a spinning
// green→orange ring with orbiting feed pellets.
// "table" floats it over a shimmering skeleton of the rows, "block" shows the
// badge alone (cards, dialogs), "page" centres it on a full-height screen.
// Styles live in style.css under "Rich loader".

interface RichLoaderProps {
  variant?: "table" | "block" | "page";
  columns?: number;
  rows?: number;
  label?: string;
}

export default function RichLoader({ variant = "table", columns = 5, rows = 5, label = "Loading" }: RichLoaderProps) {
  const cols = Math.min(Math.max(columns || 5, 2), 8);

  return (
    <div className={`ur-rich-loader ur-rich-loader--${variant}`} role="status" aria-live="polite">
      {variant === "table" && (
        <>
          <div className="ur-rich-loader__bar" />
          <div className="ur-rich-loader__skeleton" aria-hidden="true">
            {Array.from({ length: rows }).map((_, r) => (
              <div
                key={r}
                className="ur-rich-loader__row"
                style={{ gridTemplateColumns: `repeat(${cols}, 1fr)`, animationDelay: `${r * 0.08}s` }}
              >
                {Array.from({ length: cols }).map((_, c) => (
                  <span key={c} className="ur-rich-loader__cell" style={{ width: `${55 + ((r * 7 + c * 13) % 40)}%` }} />
                ))}
              </div>
            ))}
          </div>
        </>
      )}

      <div className="ur-rich-loader__badge">
        <div className="ur-rich-loader__orb">
          <span className="ur-rich-loader__ring" />
          <span className="ur-rich-loader__orbit">
            <i />
            <i />
            <i />
          </span>
          <span className="ur-rich-loader__core">
            <img src={UrjaMark} alt="" className="ur-rich-loader__mark" />
          </span>
        </div>
        <span className="ur-rich-loader__label">
          {label}
          <span className="ur-rich-loader__dots">
            <i>.</i>
            <i>.</i>
            <i>.</i>
          </span>
        </span>
      </div>
    </div>
  );
}
